import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { getLinacPositionFromImageName, getZPosFromImageName } from '../../../lib/helpers'
import Spinner from 'react-spinkit'

class ThumbnailView extends React.Component {
  static propTypes = {
    imageObjects: PropTypes.arrayOf(PropTypes.shape({
      marked: PropTypes.marked
    }))
  }

  static defaultProps = {
    imageObjects: []
  }

  getImageOrPlaceholder(imageObj) {
    if (imageObj.marked) {
      return (<img src={imageObj.marked} style={{ width: '100%' }} />)
    } else if (imageObj.raw) {
      return (<img src={imageObj.raw} style={{ width: '100%' }} />)
    } else {
      return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
          <Spinner name='double-bounce' color='red' />
        </div>
      )
    }
  }

  render () {
    const { imageObjects } = this.props
    return (
      <div className='row'>
        {
          _.map(imageObjects, (imageObj, index) => {
            return (
              <div className='col-sm-4'>
                <div style={{ margin: 20 }}>
                  <div>
                    Image Number: {index + 1}
                  </div>
                  <div>
                    Linac Position: {getLinacPositionFromImageName(imageObj.raw)}
                  </div>
                  <div>
                    Z Position: {getZPosFromImageName(imageObj.raw)}
                  </div>
                  {this.getImageOrPlaceholder(imageObj)}
                </div>
              </div>
            )
          })
        }
      </div>
    )
  }
}

export default ThumbnailView



// WEBPACK FOOTER //
// ./src/routes/Images/components/ThumbnailView.js